var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.01614C16.9968 10.5977 16.5249 12.1428 15.6439 13.4563C14.7629 14.7698 13.5124 15.7926 12.0503 16.3956C10.5882 16.9987 8.98017 17.1548 7.42939 16.8443C5.87861 16.5338 4.45466 15.7706 3.33746 14.6511C2.22025 13.5317 1.45992 12.1062 1.15255 10.5548C0.845172 9.00338 1.00453 7.39567 1.6105 5.93481C2.21647 4.47394 3.24187 3.22546 4.55711 2.34713C5.87235 1.46879 7.41841 1 8.99997 1C10.0519 0.999998 11.0935 1.20746 12.0652 1.6105C13.0368 2.01355 13.9195 2.60427 14.6625 3.34885C15.4056 4.09343 15.9946 4.97725 16.3956 5.94972C16.7967 6.92218 17.0021 7.96421 17 9.01614V9.01614Z",
    stroke: "#A1D23F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.09766L8.13726 11.2349",
    stroke: "#A1D23F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3669 8L8.13672 11.2355",
    stroke: "#A1D23F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusChecked);
export default __webpack_public_path__ + "static/media/statusChecked.8fc36ebbe6fc5b13aac178cbcb8bf5ae.svg";
export { ForwardRef as ReactComponent };